























import { Component, Vue, Prop } from 'vue-property-decorator'

import { ImageType } from './type'

@Component({})
export default class ReferenceImages extends Vue {
  @Prop({ required: false, default: [] }) private images!: ImageType[]

  private zoomImageId: string | null = null

  private onClickImage(id: string): void {
    this.zoomImageId = id
  }

  private isImage = (mime: string): boolean => {
    return mime.indexOf('image') !== -1
  }
}
